import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconNavArrowLeft = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m14.646 4.669-6.842 6.599a.974.974 0 000 1.412l6.842 6.598a.6.6 0 00.836 0l.602-.58a.6.6 0 00.18-.43.6.6 0 00-.165-.417l-.015-.015-6.078-5.862 6.078-5.861a.604.604 0 00.015-.849l-.015-.015-.602-.58a.604.604 0 00-.836 0Z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconNavArrowLeft.displayName = "IconNavArrowLeft";
